<template>
	<div class="case-notification-users">

		<InputGroup
			title="Notification Settings"
			desc="Select which users should receive notifications."
			:darkMode="true"
			:oneColumn="true"
			:skipWhiteBox="true"
			>
			<OnOffPill
				v-model="caseForm.customListEnabled"
				label="Override Default Notification List"
				instructions="By default, notifications are sent to the case owner, case manager/rep, case editors (supporting surgeons) and Meshworks Admins. If you override this setting, you can select a custom list of users to receive notifications for this case."
				:darkMode="true"
				@change="changedListOverride"
				/>
		</InputGroup>


		<InputGroup
			v-if="caseForm.customListEnabled"
			title="Notification Users"
			desc="Select which users should receive notifications."
			:darkMode="true"
			:oneColumn="true"
			:skipWhiteBox="true"
			>
			<MultiSelect
				:options="customNotifiableUsers"
				v-model="caseForm.notifiedUsers"
				:showAsTags="showAsTags"
				/>      
		</InputGroup>


		<InputGroup
			title=""
			desc=""
			:skipWhiteBox="true"
			:noLine="true"
			:condensed="true"
			:oneColumn="true"
			:fixedToBottom="true"
			>
			<Button
				label="Save"
				color="green"
				size="large"
				icon="save" 
				@click="submitNotifications"
				/>
		</InputGroup>


	</div>
</template>

<script>

import InputGroup from "@/Components/InputGroup"
import Button from "@/Components/Button"
import MultiSelect from "@/Components/MultiSelect"
import OnOffPill from "@/Components/InputOnOffPill"

export default {
	props: [
		'thisCase',
		'notifiableUsers'
	],
	components: {
		InputGroup,
		Button,
		MultiSelect,
		OnOffPill
	},
	data: () => {
		return {
			caseForm: {
				notifiedUsers: [],
				customListEnabled: false
			},
			showAsTags: [
				'case_relation',
				'notifications_enabled',
				'user_type'
			],
		}
	},
	mounted(){
		// console.log('notifiableUsers', this.notifiableUsers)
		// console.log('thisCase', this.thisCase)

		this.caseForm.notifiedUsers = this.thisCase.notification_users.map(viewer => viewer.id) // load in existing values

		this.caseForm.customListEnabled = this.thisCase.send_notifications_to_custom_list
	},
	methods: {
		changedListOverride(){
			if(this.caseForm.customListEnabled && this.caseForm.notifiedUsers.length === 0){
				console.log('set default since there are none')
				// add to caseForm.customListEnabled all in notifiableUsers that are in thisCase.editors, thisCase.dedicated_admin_user, is equal to thisCase.user_id and any that has a user_type of admin
				let defaultUsers = this.notifiableUsers.filter(user => {
					if(this.thisCase.editors.find(editor => editor.id === user.id)){
						return true
					}
					if(this.thisCase.dedicated_admin_user === user.id){
						return true
					}
					if(this.thisCase.user_id === user.id){
						return true
					}
					if(user.user_type === 'admin'){
						return true
					}
					return false
				})
				this.caseForm.notifiedUsers = defaultUsers.map(user => user.id)
			}
		},
		submitNotifications(){
			this.$inertia.post(`/admin/cases/${this.thisCase.hashid}/notification-users`, this.caseForm)  
		},
		relationToCase(userId){ 
			// check thisCase's arrays for editors and viewers if userId is in any of them, if they are, return which array they were in. Each array has objects, within each object the 'id' key relates to the user ID
			if(this.thisCase.editors.find(editor => editor.id === userId)){
				return 'Case Editor'
			}
			if(this.thisCase.viewers.find(viewer => viewer.id === userId)){
				return 'Case Viewer'
			}
			if(this.thisCase.dedicated_admin_user === userId){
				return 'Case Manager/Rep'
			}
			if(this.thisCase.user_id === userId){
				return 'Case Owner/Main Surgeon'
			}

			return false
		},
		translateUserType(userType){
			switch(userType){
				case 'admin':
					return 'Meshworks Admin'
				case 'user':
					return 'User'
				case 'team_admin':
					return 'Distributor Admin'
				case 'viewer':
					return 'Viewer'
				case 'team_user':
					return 'Distributor User'
				case 'global_viewer':
					return 'Meshworks Viewer'
				default:
					return false
			}
		}
	},
	computed: {
		customNotifiableUsers(){
			let customUsers = this.notifiableUsers.map(user => {
				let allow_contact = ['email','sms','whatsapp'].includes(user.contact_pref)
				return {
					id: user.id,
					name: user.name,
					case_relation: this.relationToCase(user.id),
					disabled: !allow_contact,
					notifications_enabled: !allow_contact ? 'Notifications Disabled' : null,
					user_type: this.translateUserType(user.user_type)
				}
			})

			// now reorder the customUsers array so that any with a case_relation are at the top
			customUsers.sort((a, b) => {
				if(a.case_relation && !b.case_relation){
					return -1
				}
				if(!a.case_relation && b.case_relation){
					return 1
				}
				return 0
			})

			return customUsers
		}
	}
}

</script>

<style scoped lang="sass">

.case-notification-users
	select[multiple]
		width: 100%
		min-height: 200px



</style>